import React from "react";
import Skeleton from "react-loading-skeleton";

const TransactionContainerSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col">
      {/* TransactionLoader Container */}
      <Skeleton
        height={50}
        className="mx-[20px] mt-[20px] rounded-lg"
        style={{ width: "calc(100% - 40px)" }}
      />

      {/* Transaction Content*/}
      <div className="border border-bg-header mt-[20px] flex flex-col rounded-lg mx-[20px]">
        <div className="border-b border-b-bg-header px-[16px] py-[18px] flex flex-row justify-between">
          <div className="flex flex-row items-center">
            <Skeleton width={24} height={24} circle className="mr-[8px]" />
            <Skeleton width={60} height={20} />
          </div>
          <Skeleton width={60} height={20} />
        </div>

        <div className="flex flex-col px-[16px] py-[16px] gap-[20px]">
          {[...Array(8)].map((_, index) => (
            <>
              <div className="flex flex-row justify-between" key={index}>
                <Skeleton width={55} height={15} />
                <Skeleton width={55} height={15} />
              </div>
              <div className="flex flex-row justify-between">
                <Skeleton width={55} height={15} />
                <Skeleton width={120} height={16} />
              </div>
            </>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TransactionContainerSkeleton;
